import script from "./AgreementRow.vue?vue&type=script&setup=true&lang=js"
export * from "./AgreementRow.vue?vue&type=script&setup=true&lang=js"

import "./AgreementRow.vue?vue&type=style&index=0&id=27fbdc44&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27fbdc44"]])

export default __exports__